import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Input, InputMobileNumber } from '../Common';
import { Grid } from '@mui/material';
import { formatPhoneValue } from '../../Utils/phone_number_utils';

const LocationContact = forwardRef((props, ref) => {
    const [firstName, setFirstName] = useState(props.data.firstName);
    const [lastName, setLastName] = useState(props.data.lastName);
    const [mainPhone, setMainPhone] = useState(props.data.mainPhone);
    const [mainPhoneExt, setMainPhoneExt] = useState(props.data.mainPhoneExt);
    const [email, setEmail] = useState(props.data.email);
    const [alternateFirstName, setAlternateFirstName] = useState(props.data.alternateFirstName);
    const [alternateLastName, setAlternateLastName] = useState(props.data.alternateLastName);
    const [alternateMainPhone, setAlternateMainPhone] = useState(props.data.alternateMainPhone);
    const [alternateMainPhoneExt, setAlternateMainPhoneExt] = useState(props.data.alternateMainPhoneExt);
    const [alternateEmail, setAlternateEmail] = useState(props.data.alternateEmail);
    const [emailError, setEmailError] = useState(null);
    const [alternateEmailError, setAlternateEmailError] = useState(null);
    const badValues = ["", null, undefined];
    const [countryCode, setCountryCode]=useState({
        mainPhone: '+1',
        mainPhoneExt: '+1',
        altMainPhone: '+1',
        altMainPhoneExt: '+1'
    })
    const [mainPhoneHasError, setMainPhoneHasError] = useState(false);
    const [mainPhoneExtHasError, setMainPhoneExtHasError] = useState(false);
    const [altMainPhoneHasError, setAltMainPhoneHasError] = useState(false);
    const [altMainPhoneExtHasError, setAltMainPhoneExtHasError] = useState(false);

    useImperativeHandle(ref, () => ({

        validate() {

            let isValid = true;
            setEmailError(null);
            setAlternateEmailError(null);

            if (validateEmail(email) == false) {
                setEmailError("Please enter a valid email address. (email@domain.com)");
                isValid = false;
            }
            if (validateEmail(alternateEmail) == false) {
                setAlternateEmailError("Please enter a valid email address. (email@domain.com)");
                isValid = false;
            }

            if (mainPhoneHasError || mainPhoneExtHasError || altMainPhoneHasError || altMainPhoneExtHasError) {
                isValid = false;
            }

            return isValid
        },
        submit() {
            return {
                firstName,
                lastName,
                mainPhone: mainPhone ? `${countryCode.mainPhone} ${formatPhoneValue(mainPhone)}`: undefined,
                mainPhoneExt: mainPhoneExt ? `${countryCode.mainPhoneExt} ${formatPhoneValue(mainPhoneExt)}` : undefined,
                email,
                alternateFirstName,
                alternateLastName,
                alternateMainPhone: alternateMainPhone ? `${countryCode.altMainPhone} ${formatPhoneValue(alternateMainPhone)}`: undefined,
                alternateMainPhoneExt: alternateMainPhoneExt ? `${countryCode.altMainPhoneExt} ${formatPhoneValue(alternateMainPhoneExt)}` : undefined,
                alternateEmail,
            }
        }

    }));

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (badValues.includes(email)) {
            return true;
        }
        return emailRegex.test(email);
    };

    const handlechangeCountrycode=(name, value)=>{
        setCountryCode({
            ...countryCode,
            [name]: value,
        })
    }

    return (
        <>
            <div className="wizardTitle">
                <span>Main Contact</span>
            </div>
            <Grid container spacing={{ xs: 2, md: 4 }} mt={{ xs: 0, md: 0.5 }}>
                <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        fullWidth
                        value={firstName}
                        label="First Name"
                        onChange={e => setFirstName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        fullWidth
                        value={lastName}
                        label="Last Name"
                        onChange={e => setLastName(e.target.value)}
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ marginTop: { xs: 0, md: "2px" } }} spacing={{ xs: 2, md: 4 }}>
                <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                    <InputMobileNumber
                        fullWidth
                        value={mainPhone}
                        label="Main Phone"
                        onChange={e => setMainPhone(e.target.value)}
                        getCountryCode={(value) => handlechangeCountrycode('mainPhone', value)}
                        isValid={(error) => setMainPhoneHasError(error)}
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                    <InputMobileNumber
                        fullWidth
                        value={mainPhoneExt}
                        label="Main Phone Extension"
                        onChange={e => setMainPhoneExt(e.target.value)}
                        getCountryCode={(value) => handlechangeCountrycode('mainPhoneExt', value)}
                        isValid={(error) => setMainPhoneExtHasError(error)}
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ marginTop: { xs: 0, md: "2px" } }} spacing={{ xs: 2, md: 4 }}>
                <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                    <Input
                        fullWidth
                        value={email}
                        label="Email Address"
                        onChange={e => setEmail(e.target.value)}
                        error={emailError}
                        helperText={emailError}
                    />
                </Grid>
            </Grid>

            <div className='mailing-address-or-contact' style={{ marginTop: "2%" }}>
                <div className="wizardTitle">
                    <span>Alternate Contact (optional)</span>
                </div>
                <Grid container spacing={{ xs: 2, md: 4 }} mt={{ xs: 0, md: -4 }}>
                    <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                        <Input

                            fullWidth
                            value={alternateFirstName}
                            label="First Name"
                            onChange={e => setAlternateFirstName(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                        <Input

                            fullWidth
                            value={alternateLastName}
                            label="Last Name"
                            onChange={e => setAlternateLastName(e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ marginTop: { xs: 0, md: "2px" } }} spacing={{ xs: 2, md: 4 }}>
                    <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                     <InputMobileNumber
                        fullWidth
                        value={alternateMainPhone}
                        label="Main Phone"
                        onChange={e => setAlternateMainPhone(e.target.value)}
                        getCountryCode={(value) => handlechangeCountrycode('altMainPhone', value)}
                        isValid={(error) => setAltMainPhoneHasError(error)}
                    />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                        <InputMobileNumber
                            fullWidth
                            value={alternateMainPhoneExt}
                            label="Main Phone Extension"
                            onChange={e => setAlternateMainPhoneExt(e.target.value)}
                            getCountryCode={(value) => handlechangeCountrycode('altMainPhoneExt', value)}
                            isValid={(error) => setAltMainPhoneExtHasError(error)}
                    />
                    </Grid>
                </Grid>

                <Grid container sx={{ marginTop: { xs: 0, md: "2px" } }} spacing={{ xs: 2, md: 4 }}>
                    <Grid item xs={12} md={6} lg={6} style={{ marginBottom: '5px' }}>
                        <Input
                            fullWidth
                            value={alternateEmail}
                            label="Email Address"
                            onChange={e => setAlternateEmail(e.target.value)}
                            error={alternateEmailError != null}
                            helperText={alternateEmailError}
                        />
                    </Grid>
                </Grid>
            </div>
        </>);
});

export default LocationContact;
